export const visit = (vm, at) => {
at({ "en": { "multiAccountReferenceResolvers": { "duplicateLabelHandler": { "sharedAcross": "Shared across {{ accountNames }}", "alsoKnownAs": "Also known as: {{ aliases }}" } } } });
};